import profile from "../../../images/profileImage.png";
import {buildImageUrl} from "../../../utils/imageUrlBuilder";
import {userRoleList} from "../../../utils/constants";
import Coverimage from "../../../images/Cover Technicien.png";
import {Link} from "react-router-dom";
import StarIcon from "../../../images/icons/starIcon";
import CrownIcon from "../../../images/icons/crownIcon";
import Loader from "../../components/shared/Loader";
import ImageComponent from "../../components/shared/ImageComponent";
import {useChatRoom} from "../../../hooks/useChat";
const HeadBanner = ({data}) => {
  const {imageUri, firstName, lastName, selectedRole, avgRating, isOnline} =
    data?.User;
  const {onStartDirectChat} = useChatRoom();

  return (
    <div className="lg:col-span-4 w-full">
      <div className="profile w-full bg-white !rounded-xl  px-3 pt-3 pb-0">
        <div className="profile-head">
          <div className="photo-content hidden md:flex">
            <img
              alt="cover"
              src={Coverimage}
              className="min-h-[106px]  w-full rounded-xl object-cover"
            />
          </div>
          <div className="profile-info !flex p-2 md:!p-0  md:ml-12 ">
            <div className="profile-photo min-w-20 w-20 md:h-10 !mt-0 md:!-mt-[20px] relative ">
              {!!avgRating && (
                <div className="bg-[#FFC107] w-[40px] flex justify-center gap-[2px] items-center leading-none px-[3px] py-[2px] text-white text-[12px] absolute bottom-0  md:-bottom-11 !rounded-lg left-[50%] -translate-x-[50%] ">
                  {Number(avgRating).toFixed(2)}
                  <StarIcon className="fill-white stroke-none w-3 h-3" />
                </div>
              )}
              <ImageComponent
                src={buildImageUrl(imageUri)}
                className="w-20 rounded-full aspect-square ring-4 ring-white object-cover"
                alt="profile"
                fallback={
                  <img
                    src={profile}
                    className="w-20 rounded-full aspect-square ring-4 ring-white object-cover"
                    alt="profile"
                  />
                }
              />
            </div>
            <div className=" flex-grow !flex justify-between">
              <div className="profile-name px-3 !pt-4 !pb-5">
                <div className=" text-[#19295C] font-bold mb-0 capitalize">{`${lastName} ${firstName}`}</div>
                <div className="flex justify-start items-center gap-2 text-[#FF6600] font-normal text-sm">
                  {selectedRole === userRoleList.TECHNICIAN
                    ? "Prestataire"
                    : "Client"}
                  {/* <i className="fi fi-rr-chess-queen flex items-center"></i> */}
                  {selectedRole === userRoleList.TECHNICIAN &&
                    data?.isProfessional === true && (
                      <CrownIcon className="w-4 h-4 m-0" />
                    )}
                </div>
              </div>
              <div className="flex justify-end items-center">
                <div className="hidden md:flex justify-center h-full border-l border-solid items-center py-[14px] px-8 text-[#19295C] font-bold text-sm ">
                  {data?.viewCount ?? 0} vue(s)
                </div>
                {isOnline ? (
                  <div className="hidden md:flex gap-2 justify-center h-full border-l border-solid items-center py-[14px] px-8 text-[#19295C] font-bold text-sm ">
                    <div className="w-2 h-2 bg-green-600 rounded-full" />
                    Disponible
                  </div>
                ) : (
                  <div className="hidden md:flex gap-2 justify-center h-full border-l border-solid items-center py-[14px] px-8 text-[#19295C] font-bold text-sm ">
                    <div className="w-2 h-2 bg-red-600 rounded-full" />
                    Hors ligne
                  </div>
                )}
                {data?.User?.selectedRole === userRoleList.TECHNICIAN && (
                  <div className="hidden md:flex gap-2 justify-center h-full border-l border-solid items-center py-[14px] px-8 text-[#19295C] font-bold text-sm ">
                    <button
                      data-testid="provider-contact"
                      onClick={() => {
                        onStartDirectChat({technicianId: data?.id});
                      }}
                      className="font-bold flex justify-center items-center gap-2  !px-4 py-[13px] text-base min-w-[100px] w-full  !rounded-lg bg-gradient-to-r from-[#0022AA] to-[#1A64B9] text-white sw-btn-next"
                    >
                      <i className="fi fi-rr-paper-plane flex items-center"></i>
                      <span className="text-[14px] capitalize">
                        Contacter {data?.User?.firstName}
                      </span>
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeadBanner;
